module.exports = __webpack_public_path__ + "img/5.bbe15d4b.jpg";